export enum AvmPaths {
    ROOT = "avm",
    ASSETS = "assets",
    MOVEMENTS = "movements",
    IMPORT = "import",
    RESTWERT = "restwertverzeichnis",
    SPIEGEL = "anlagenspiegel",
    FORECAST = "afa-vorschau",
    INVENTORY = "inventarliste",
    BATCHES = "buchungsstapel",
    SETTINGS = "einstellungen",
    RECHENREGELN = "rechenregeln",
    NEW = "new",
}
